import { nlNL } from "@mui/x-data-grid/locales";

export let muiDataGridLocale = null;

export function setMuiDataGridLocale(lang) {

  if (lang === "nl") {
    muiDataGridLocale = nlNL.components.MuiDataGrid.defaultProps.localeText;

    // temporary fix for wrong translations - MFGEU12-209
    // are updated in latest repro on github  but not yet published
    muiDataGridLocale.columnsManagementSearchTitle = "Zoeken";
    muiDataGridLocale.columnsManagementShowHideAllText = "Toon/Verberg Alle"
    muiDataGridLocale.columnsManagementNoColumns = "Geen kolommen";

  } else {
    muiDataGridLocale = null;
  }
}